import { useTranslation } from 'react-i18next'

import i18n from '@/lib/i18n'

export const usePrivacyPolicyTitle = () => {
  const { t } = useTranslation()
  return t('privacyPolicy.title')
}

export const PRIVACY_POLICY_TITLE = i18n.t('contact.menu.privacyPolicy')
